import script from "./HeroSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroSlider.vue?vue&type=script&setup=true&lang=js"

import "./HeroSlider.vue?vue&type=style&index=0&id=236420ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236420ec"]])

export default __exports__